<template>
    <div class="px-3 lg:px-12 py-16 lg:pt-32">
        <div class="flex justify-center items-center mt-14 lg:mt-0 lg:absolute lg:z-[100] lg:left-1/2 lg:-translate-x-1/2 lg:top-[2.5rem]">
            <MoleculeSingleSearch class="!text-black" :value="query" @input="update" />
        </div>

        <div class="mt-10 flex">
        <!--
            <aside class="fixed w-[60px] top-[260px]">
                <div class="top-12 flex flex-col">
                    <div v-for="letter in letterList" class="flex">
                        <a
                            class="text-grey uppercase text-xs"
                            href="#"
                            v-scroll-to="{ el: '#letter_' + letter }"
                        >
                            {{ letter.toUpperCase() }}
                        </a>
                    </div>
                </div>
            </aside>
        -->

            <div class="flex justify-center w-full">
                <div class="max-w-[66.6666666667%] overflow-hidden text-center">
                    <div v-for="data in filteredList">
                        <template v-if="isNewLetter(data[compareAttribute])">
                            <section :id="'letter_' + getFirstLetter(data[compareAttribute])">
                                <div class="py-[15px] md:py-[30px] lg:py-[60px] text-[12px] leading-[15px]">{{ getFirstLetter(data[compareAttribute]) }}</div>
                            </section>
                        </template>
                        <a v-if="urlAttribute && data[urlAttribute]" :href="addHttp(data[urlAttribute])" target="_blank" >
                            <div class="hover:underline overflow-hidden text-ellipsis whitespace-nowrap text-[28px] leading-[35px] md:text-[40px] md:leading-[47px] lg:text-[60px] lg:leading-[70px]">{{ data[attribute] }}</div>
                        </a>
                        <router-link v-if="routeName && (isPublishedAttribute ? data[isPublishedAttribute] : true)" :to="{ name: routeName, params: { id: data.id, slug: data.slug } }">
                            <div class="hover:underline overflow-hidden text-ellipsis whitespace-nowrap text-[28px] leading-[35px] md:text-[40px] md:leading-[47px] lg:text-[60px] lg:leading-[70px]">{{ data[attribute] }}</div>
                        </router-link>
                        <div v-else class="overflow-hidden text-ellipsis whitespace-nowrap text-[28px] leading-[35px] md:text-[40px] md:leading-[47px] lg:text-[60px] lg:leading-[70px]">{{ data[attribute] }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import MoleculeSingleSearch from "../molecules/MoleculeSingleSearch.vue";
import SingleSearchMixin from "../../../mixins/single-search";
import {mapState} from "vuex";
import prependHttp from "prepend-http";

export default {
    name: 'OrganismAlphabetList',
    components: {MoleculeSingleSearch},
    mixins: [SingleSearchMixin],
    props: {
        data: {
            type: Array,
            required: true,
        },
        attribute: {
            type: String,
            required: true,
        },
        compareAttribute: {
            type: String,
            required: true,
        },
        isPublishedAttribute: {
            type: String,
        },
        routeName: {
            type: String,
        },
        urlAttribute: {
            type: String,
        },
    },
    methods: {
        update(searchedText) {
            this.$emit('search', searchedText)
        },
        addHttp(url) {
            if (url) {
                return prependHttp(url);
            }
        },
    },
    computed: {
        filteredList() {
            return this.data.map((x) => x).filter(d => {
                return d[this.attribute].toLowerCase().includes(this.query.toLowerCase())
            })
        },
        letterList() {
            const letterList = []
            Object.values(this.filteredList).forEach(data => {
                let first = data[this.compareAttribute].charAt(0);
                if (letterList.indexOf(first) === -1) {
                    letterList.push(first)
                }
            })
            return letterList;
        },
        ...mapState('menu', {
            query: state => state.singleSearch.query
        }),
    }
}
</script>
